import React from 'react';
import { translate } from 'react-i18next';
import { getStyle } from '../../../utils/utils';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBMobileCard from '../../shared/CBMobileCard';

// One vehicle in the settings table: selects that save on change. Only
// toimipiste is shown for a fleet outside every workshop chain — ajoneuvovastaava
// and vastuukorjaamo are chain care service concepts (`showChainFields`).
// PureComponent: the fleet list is unpaginated, so a row must not re-render
// unless its own props changed.
class OrganizationVehicleSettingsRow extends React.PureComponent {
  handleChange = (field, option) => {
    const { row, onFieldChange } = this.props;
    const value = option.value === '' ? null : Number(option.value);
    onFieldChange(row.vehicle_id, field, value);
  };

  renderSelect = (field, currentValue, options, screenSize) => {
    const {
      row, rowStatus, canEdit,
    } = this.props;
    const saving = !!(rowStatus && rowStatus.saving);
    // Re-key on error so a rejected pick falls back to the stored value
    // (CBSelectField keeps the picked value in its own state).
    const errorKey = rowStatus && rowStatus.error ? 'err' : 'ok';
    return (
      <CBSelectField
        key={row.vehicle_id + '-' + field + '-' + errorKey}
        name={field}
        value={currentValue == null ? '' : String(currentValue)}
        options={options}
        onChange={(option) => this.handleChange(field, option)}
        inputStyle={getStyle(screenSize, styles, 'select')}
        optionStyle={getStyle(screenSize, styles, 'optionStyle')}
        containerStyle={{ margin: 0 }}
        disabled={!canEdit || saving}
      />
    );
  };

  renderStatus = (screenSize) => {
    const { t, rowStatus } = this.props;
    if (rowStatus && rowStatus.saving) {
      return <span style={getStyle(screenSize, styles, 'statusSaving')}>{t('saving')}</span>;
    }
    if (rowStatus && rowStatus.error) {
      return <span style={getStyle(screenSize, styles, 'statusError')}>{t('saveFailed')}</span>;
    }
    return null;
  };

  render() {
    const {
      t, row, screenSize, showChainFields, vehicleManagerOptions, workshopOptions, businessUnitOptions,
    } = this.props;
    const model = [row.manufacturer, row.model_name].filter(Boolean).join(' ');
    const workshopControl = row.has_care_service
      ? this.renderSelect('assigned_workshop', row.assigned_workshop_id, workshopOptions, screenSize)
      : <span style={getStyle(screenSize, styles, 'muted')}>{t('noCareService')}</span>;

    if (screenSize === 'small') {
      const badges = [];
      const status = this.renderStatus(screenSize);
      if (status) badges.push(status);
      const fields = [];
      const allFields = [{ label: t('headingVehicle'), value: (row.registration_number || '-') + ' ' + model }];
      if (showChainFields) {
        fields.push({ label: t('headingVehicleManager'), value: this.renderSelect('responsible_user', row.responsible_user, vehicleManagerOptions, screenSize) });
        fields.push({ label: t('headingWorkshop'), value: workshopControl });
        allFields.push({ label: t('headingVehicleManager'), value: row.responsible_user_name || '-' });
        allFields.push({ label: t('headingWorkshop'), value: row.assigned_workshop_name || '-' });
      }
      fields.push({ label: t('headingBusinessUnit'), value: this.renderSelect('business_unit', row.business_unit, businessUnitOptions, screenSize) });
      allFields.push({ label: t('headingBusinessUnit'), value: row.business_unit_name || '-' });
      return (
        <CBMobileCard
          title={row.registration_number || '-'}
          dialogTitle={row.registration_number || '-'}
          subtitle={model}
          badges={badges}
          fields={fields}
          allFields={allFields}
        />
      );
    }

    return (
      <tr style={getStyle(screenSize, styles, 'row')}>
        <td style={getStyle(screenSize, styles, 'tableTd')}>
          <div style={getStyle(screenSize, styles, 'registration')}>{row.registration_number || '-'}</div>
          <div style={getStyle(screenSize, styles, 'model')}>{model}</div>
        </td>
        {showChainFields && (
          <td style={getStyle(screenSize, styles, 'tableTd')}>
            {this.renderSelect('responsible_user', row.responsible_user, vehicleManagerOptions, screenSize)}
          </td>
        )}
        {showChainFields && (
          <td style={getStyle(screenSize, styles, 'tableTd')}>
            {workshopControl}
          </td>
        )}
        <td style={getStyle(screenSize, styles, 'tableTd')}>
          {this.renderSelect('business_unit', row.business_unit, businessUnitOptions, screenSize)}
        </td>
        <td style={getStyle(screenSize, styles, 'tableTdStatus')}>
          {this.renderStatus(screenSize)}
        </td>
      </tr>
    );
  }
}

const styles = {
  default: {
    row: {
      marginBottom: 8,
    },
    tableTd: {
      border: '1px solid rgba(255, 255, 255, .3)',
      color: '#FFFFFF',
      padding: '4px 8px',
      verticalAlign: 'middle',
    },
    tableTdStatus: {
      paddingLeft: 8,
      paddingRight: 8,
      minWidth: 120,
    },
    registration: {
      fontFamily: 'TitilliumWeb-SemiBold',
      fontSize: 14,
      whiteSpace: 'nowrap',
    },
    model: {
      fontSize: 12,
      color: 'rgba(255, 255, 255, 0.7)',
    },
    select: {
      minWidth: 180,
      height: 34,
      border: '1px solid rgb(255 255 255 / 55%)',
      borderRadius: 50,
      backgroundColor: 'transparent',
      color: '#FFF',
      padding: '0px 0px 0px 12px',
      fontSize: 13,
    },
    optionStyle: {
      backgroundColor: 'rgb(0, 149, 218)',
    },
    muted: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 13,
    },
    statusSaving: {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: 12,
    },
    statusError: {
      color: '#ffb4a2',
      fontSize: 12,
      fontFamily: 'TitilliumWeb-SemiBold',
    },
  },
};

export default translate('VehicleSettings')(OrganizationVehicleSettingsRow);
